import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyWeaveFormSubmissionIllustration = lazy(() => import('./svg-components/weave-form-submission-illustration'));

const WeaveFormSubmissionIllustration = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyWeaveFormSubmissionIllustration {...rest} />
  </Suspense>
);

export default WeaveFormSubmissionIllustration;
